export const getEmailPattern = () => {
    return /^\s*[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}\s*$/i
}

export const getPostalCodePattern = () => {
    return /^\s*[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d\s*$/i
}

export const getSpecialCharacterPattern = () => {
    // OLD PATTERN- /^\s*[\w\s-]*\s*$/
    return /^\s*[\w\s.-]*\s*$/
}
export const getDatePickerPattern = () => {
    return /^\d{2}\/\d{2}\/\d{4}$/
}
export const getPhoneNumPattern = () => {
    return /^\s*[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}\s*$/i
}
export const parseDate = (date: any) => {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${month}/${day}/${year}`
}

export const formatInputDate = (value: string): string => {
    const cleanedValue = value.replace(/[^0-9]/g, '')
    let formattedValue = cleanedValue

    if (cleanedValue.length >= 3) {
        formattedValue = `${cleanedValue.slice(0, 2)}/${cleanedValue.slice(2)}`
    }

    if (cleanedValue.length >= 5) {
        formattedValue = `${formattedValue.slice(0, 5)}/${cleanedValue.slice(
            4
        )}`
    }
    return formattedValue
}
